export default function Skel() {
  return <div className="bg-gray-100 min-h-[150px] px-2 rounded-xl w-full animate-pulse" />;
}
